import { useBreakpointValue } from '@vimeo/bokeh';

import { playerGridSizeMap, thumbnailGridSizeMap } from '../utils/constants';
import { GridSize } from '../utils/types';

interface Props {
  gridSize?: GridSize;
  isMobilePreview?: boolean;
  showVideoPlayerCards?: boolean;
}

export const useVideoGrid = ({ gridSize = 's', isMobilePreview, showVideoPlayerCards }: Props) => {
  const effectiveGridSize = showVideoPlayerCards && gridSize === 's' ? 'm' : gridSize;
  const gridSizeMap = showVideoPlayerCards ? playerGridSizeMap : thumbnailGridSizeMap;
  const gridSizeConfig = gridSizeMap[effectiveGridSize];

  const mobilePreviewGridColumns = gridSizeConfig.base;
  const customizationGridSizeColumns = useBreakpointValue(gridSizeConfig);
  const numColumns = isMobilePreview ? mobilePreviewGridColumns : customizationGridSizeColumns;

  return { effectiveGridSize, gridGap: 'lg', numColumns };
};
